import type { ProxyRequiredTaskParams, _IsTaskType } from "../_BaseTaskRequest";

import type { KeyCaptchaTaskBaseParams } from "./Base/_KeyCaptchaTaskBase";

import { KeyCaptchaTaskBase } from "./Base/_KeyCaptchaTaskBase";

type KeyCaptchaTaskParams = ProxyRequiredTaskParams<KeyCaptchaTaskBaseParams>;

/**
 * Token-based method for automated solving of Capy Puzzle Captcha.
 * @extends {KeyCaptchaTaskBase}
 * @see {@link https://2captcha.com/api-docs/keycaptcha}
 */
export class KeyCaptchaTask extends KeyCaptchaTaskBase implements _IsTaskType {

  /**
  * @type {boolean} _isKeyCaptchaTask - Only used for correct method overloading intellisense
  */
  readonly _isKeyCaptchaTask: _IsTaskType["_isKeyCaptchaTask"] = true;

  /**
  * Create KeyCaptchaTask
  * @see {@link https://2captcha.com/api-docs/keycaptcha}
  * @param {Object} params - KeyCaptchaTaskParams
  * @param {string} [params.websiteURL] - The full URL of target web page where the captcha is loaded. We do not open the page, not a problem if it is available only for authenticated users
  * @param {string} [params.s_s_c_user_id] - The value of s_s_c_user_id parameter found on page
  * @param {string} [params.s_s_c_session_id] - The value of s_s_c_session_id parameter found on page
  * @param {string} [params.s_s_c_web_server_sign] - The value of s_s_c_web_server_sign parameter found on page
  * @param {string} [params.s_s_c_web_server_sign2] - The value of s_s_c_web_server_sign2 parameter found on page
  * @param {string} [params.proxyAddress] -	Proxy IP address or hostname
  * @param {string} [params.proxyLogin] - Login for basic authentication on the proxy
  * @param {string} [params.proxyPassword] - Password for basic authentication on the proxy
  * @param {string} [params.proxyType] - Type of your proxy: HTTP, HTTPS, SOCKS4, SOCKS5
  * @param {string} [params.proxyPort] - Proxy port
  */
  constructor (params: KeyCaptchaTaskParams) {
    super(params, "KeyCaptchaTask");
  }
}
